import React from "react";
import ReactTooltip from "react-tooltip";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const FieldHelpText = (props: Props) => {
  const { children } = props;

  return (
    <>
      <HelpIcon icon={faQuestionCircle} data-tip={children} />
      <Tooltip />
    </>
  );
};

const HelpIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.muted};

  :hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

const Tooltip = styled(ReactTooltip)`
  max-width: 200px;
`;

type Props = {
  children: string;
};

export default FieldHelpText;
